/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productLeaseConfiguratorNodes = Array.from(document.querySelectorAll('.product-lease-configurator'));
if (productLeaseConfiguratorNodes.length) {
    import(/* webpackChunkName: "ProductLeaseConfigurator" */ './components/ProductLeaseConfigurator').then(({ default: ProductLeaseConfigurator }) => {
        productLeaseConfiguratorNodes.forEach((node) => render(<ProductLeaseConfigurator {...parseDataToProps(node.dataset)} />, node));
    });
}
